module.exports = __webpack_public_path__ + "img/banner_lsf16_atlantis.53dd0da3.jpg";